import { Component } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import MemberSetCreate from "./MemberSetCreate";
import MemberSetCreateFiltered from "./MemberSetCreateFiltered";
import MemberSetDetail from "./MemberSetDetail";
import MemberSets from "./MemberSets";

export default class MemberSetsRouter extends Component<RouteComponentProps<unknown, unknown, { sourceMemberSetId: number }>> {
  constructor(props: RouteComponentProps<unknown, unknown, { sourceMemberSetId: number }>) {
    super(props);
  }

  public render() {
    return (
      <Switch location={this.props.location}>
        <Route
          exact={true}
          path={this.props.match.url}
          render={(props) => <MemberSets {...props} />}
        />

        <Route
          exact={true}
          path={`${this.props.match.url}/create`}
          render={(props) => <MemberSetCreate {...props} />}
        />

        <Route
          exact={true}
          path={`${this.props.match.url}/create-filtered`}
          component={MemberSetCreateFiltered}
        />

        <Route
          exact={true}
          path={`${this.props.match.url}/:memberSetId/detail`}
          component={MemberSetDetail}
        />
      </Switch>
    );
  }
}
